/** ロゴの種類の定数 */
export enum LogoType {
  Logo = 'logo',
  WithUnroof = 'collaboration_with_unroof'
}

export default LogoType
